// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3MffI","location":"Header_location__2gm99"};